export default __webpack_public_path__ + "static/help_05_03_1-f75e33851fa2feeffc644d29524f82c7.png";